import { render } from "./AboutS1.vue?vue&type=template&id=9036f450&scoped=true"
import script from "./AboutS1.vue?vue&type=script&lang=js"
export * from "./AboutS1.vue?vue&type=script&lang=js"

import "./AboutS1.vue?vue&type=style&index=0&id=9036f450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9036f450"]])

export default __exports__